import { useSelector } from 'react-redux';
import { config } from '../../../config';
import { EnterCodesModal } from './EnterCodesModal';
import { codeWordsValidatedSelector } from '../../redux/codeWordsSlice';
import { getPromotionSelector } from '../../redux/init/selectors';

export const EnterCodesWrapper = ({ isHomePage, className, children }) => {
  const codeWordsValidated = useSelector(codeWordsValidatedSelector);
  const { emailcapture, papercapture, keywords, open } = useSelector(getPromotionSelector);
  const hideEmail = emailcapture !== 'Y';
  const hideNewspaper = papercapture !== 'Y';
  const hideCodewords = keywords <= 0;
  const hideCodesModal = hideEmail && hideNewspaper && hideCodewords;
  const hideSearchBar = open === 'N';

  if (hideSearchBar) return null;

  if (config.siteCode === 'RP' && !codeWordsValidated && !hideCodesModal) {
    return <EnterCodesModal isHomePage={isHomePage} className={className} />;
  }

  return children;
};

export const HideIfCodeWordsNotEntered = ({ children }) => {
  const codeWordsValidated = useSelector(codeWordsValidatedSelector);

  const { emailcapture, papercapture, keywords } = useSelector(getPromotionSelector);
  const hideEmail = emailcapture !== 'Y';
  const hideNewspaper = papercapture !== 'Y';
  const hideCodewords = keywords <= 0;
  const hideCodesModal = hideEmail && hideNewspaper && hideCodewords;

  if (config.siteCode === 'RP' && !codeWordsValidated && !hideCodesModal) {
    return null;
  }

  return children;
};
